import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import { SHADOW_FILTER_ID } from '../../constants';
export var StyledRect = styled.rect(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    return props.dropShadow && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      filter: url(#", ");\n    "], ["\n      filter: url(#", ");\n    "])), SHADOW_FILTER_ID);
});
var templateObject_1, templateObject_2;
